export const itemsPerPage = 10;

export default {
  itemsPerPage,
};
